export const progressIndicatorGapMap = {
  comfortable: {
    small: ['space.075', "var(--ds-space-075, 6px)"],
    default: ['space.100', "var(--ds-space-100, 8px)"],
    large: ['space.150', "var(--ds-space-150, 12px)"]
  },
  cozy: {
    small: ['space.050', "var(--ds-space-050, 4px)"],
    default: ['space.075', "var(--ds-space-075, 6px)"],
    large: ['space.100', "var(--ds-space-100, 8px)"]
  },
  compact: {
    small: ['space.025', "var(--ds-space-025, 2px)"],
    default: ['space.050', "var(--ds-space-050, 4px)"],
    large: ['space.075', "var(--ds-space-075, 6px)"]
  }
};
export const sizes = {
  small: 4,
  default: 8,
  large: 12
};
export const varDotsSize = '--ds-dots-size';
export const varDotsMargin = '--ds-dots-margin';